import { PublicClientApplication } from '@azure/msal-browser';

const CLIENT_ID = import.meta.env.VITE_MICROSOFT_CLIENT_ID as string;
const REDIRECT_URI = `${window.location.origin}/redirect.html`;
const SCOPES = ['openid', 'profile', 'email', 'User.Read'];

const msalInstance: Promise<PublicClientApplication> = (async () => {
  const instance = new PublicClientApplication({
    auth: {
      clientId: CLIENT_ID,
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: REDIRECT_URI,
      postLogoutRedirectUri: REDIRECT_URI,
    },
    cache: { cacheLocation: 'localStorage' },
  });

  await instance.initialize();

  return instance;
})();

export async function msalWebLogin(
  nonce: string,
): Promise<{ idToken: string; accessToken: string }> {
  const instance = await msalInstance;

  const result = await instance.loginPopup({
    scopes: SCOPES,
    nonce,
  });

  return {
    idToken: result.idToken,
    accessToken: result.accessToken,
  };
}
